// extracted by mini-css-extract-plugin
export default {"root":"UncreditedPaymentsContent_root__7Zqvg"};